import React, { Component } from "react";
import { getBitcoinsTrade } from "../services/bitcoinsTradeService";
import auth from "../services/authService";
import Spinner from "./common/spinner";
import NotFound from "./notFound";
import moment from "moment";
import ModalImage from "react-modal-image";
import { Link } from "react-router-dom";
import {
  bTradeCompletionStatus,
  bTradeApprovalStatus,
} from "../services/cardTradeService";
import { saveCredit } from "../services/creditService";

class BTradeInfo extends Component {
  state = {
    loading: false,
    amount: "",
    bank: "",
    wallet_type: "",
    expected_earning: "",
    trade_reference: "",
    approvedBy: "",
    closedBy: "",
    approve_status_updated_at: "",
    close_status_updated_at: "",
    image: [],
    isApproved: "",
  };

  async componentDidMount() {
    const tradeId = this.props.match.params.id;

    this.setState({ loading: true });
    const {
      amount,
      bank,
      wallet_type,
      expected_earning,
      trade_reference,
      approvedBy,
      closedBy,
      approve_status_updated_at,
      close_status_updated_at,
      image,
      isApproved,
    } = (await getBitcoinsTrade(tradeId)).data.data;
    console.log((await getBitcoinsTrade(tradeId)).data.data);
    this.setState({ loading: false });
    this.setState({
      amount,
      bank,
      wallet_type,
      expected_earning,
      trade_reference,
      approvedBy,
      closedBy,
      approve_status_updated_at,
      close_status_updated_at,
      image: image ? image : [],
      isApproved,
    });
  }

  getPagedData = () => {
    const { users } = this.state;

    return { data: users };
  };

  handleTradeCompletionSwitch = async (btrade) => {
    await bTradeCompletionStatus(btrade);
    this.setState({ btrade });
  };

  handleTradeApprovalSwitch = async (btrade) => {
    await bTradeApprovalStatus(btrade);
    this.setState({ btrade });
  };

  render() {
    const {
      loading,
      amount,
      bank,
      wallet_type,
      expected_earning,
      trade_reference,
      approvedBy,
      closedBy,
      approve_status_updated_at,
      close_status_updated_at,
      image,
      isApproved,
    } = this.state;
    const _id = this.props.match.params.id;
    const { isAdmin } = auth.getCurrentUser();
    return isAdmin ? (
      <React.Fragment>
        {loading && <Spinner message="" />}
        <div className="card shadow mb-4">
          <div className="card-header py-3">
            <h6 className="m-0 font-weight-bold text-primary">
              {trade_reference}
            </h6>
          </div>
          <div className="action_buttons" style={{ marginTop: 10 }}>
            {isApproved ? (
              <button
                className="btn btn-primary"
                style={{ marginLeft: 20 }}
                onClick={async () => {
                  this.setState({ loading: true });
                  await this.handleTradeApprovalSwitch({
                    _id: _id,
                    isApproved: false,
                  });
                  this.setState({ isApproved: false, loading: false });
                }}
              >
                Disapprove Trade
              </button>
            ) : (
              <button
                className="btn btn-primary"
                style={{ marginLeft: 20 }}
                onClick={async () => {
                  this.setState({ loading: true });
                  const re = await this.handleTradeApprovalSwitch({
                    _id: _id,
                    isApproved: true,
                  });
                  this.setState({ isApproved: true, loading: false });
                }}
              >
                Approve Trade
              </button>
            )}
            {
              <Link
                to={`/closed-trades/${this.props.match.params.id}`}
                className=" btn btn-danger"
                style={{ marginLeft: 20 }}
              >
                Close Trade
              </Link>
            }
          </div>
          <div className="card-body">Bitcoin Value: {amount}</div>
          <div className="card-body">Wallet Type: {wallet_type.name}</div>
          <div className="card-body">Expected Earnings: {expected_earning}</div>
          <div className="card-body">
            Bank Account Name: {bank && bank.accountName}
          </div>
          <div className="card-body">
            Bank Account Number: {bank && bank.accountNumber}
          </div>
          <div className="card-body">Bank Name: {bank && bank.bankName}</div>
          <div className="card-body">Trade Ref: {trade_reference}</div>
          {approvedBy && approve_status_updated_at && (
            <div className="card-body">
              Trade Approval Status Updated By: {approvedBy} on{" "}
              {moment(approve_status_updated_at).format("LLLL")}
            </div>
          )}
          {closedBy && close_status_updated_at && (
            <div className="card-body">
              Trade Completion Status Updated By: {closedBy} on{" "}
              {moment(close_status_updated_at).format("LLLL")}
            </div>
          )}
          {image.map((value, index) => {
            return (
              <div key={index}>
                {image && value.location && (
                  <div
                    className="mt-4 ml-4"
                    style={{ color: "#000524", fontWeight: "bold" }}
                  >
                    Uploaded Proof
                  </div>
                )}
                {value.location && (
                  <div className="col-md-6 mt-4 mb-4">
                    <ModalImage
                      small={value.location}
                      large={value.location}
                      alt="Uploaded Proof"
                      showRotate={true}
                      hideZoom={true}
                      className="trade-image"
                    />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </React.Fragment>
    ) : (
      <NotFound />
    );
  }
}

export default BTradeInfo;
